module.exports = __webpack_public_path__ + "img/上海交通大学logo.935c88da.png";